var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box", attrs: { shadow: "hover" } }, [
    _c("h1", [_vm._v("Remetentes do WhatsApp")]),
    _c(
      "div",
      { staticClass: "containerBotao" },
      [
        _c("span", [_vm._v("Remetentes registrados")]),
        _c(
          "el-button",
          {
            staticClass: "botaoAdd",
            attrs: { type: "primary", icon: "el-icon-plus", id: "botao-add" },
            on: { click: _vm.registrarCliente }
          },
          [_vm._v("Registrar remetente")]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modulosContainer" },
      _vm._l(_vm.clientes, function(cliente) {
        return _c(
          "div",
          { key: cliente.clientId, staticClass: "modulo" },
          [
            _c(
              "el-row",
              {
                staticClass: "nomeModuloContainer",
                attrs: { type: "flex", justify: "space-between" }
              },
              [
                _c("span", { staticClass: "titulo" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.encurtarString(
                          cliente.clientId.length,
                          15,
                          cliente.clientId
                        )
                      )
                    )
                  ])
                ]),
                _c(
                  "el-dropdown",
                  { attrs: { trigger: "click" } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 2 } },
                      [
                        _c("i", {
                          staticClass: "fa fa-ellipsis-v",
                          style: { "font-size": "22px", cursor: "pointer" }
                        }),
                        [
                          _c(
                            "el-dropdown-menu",
                            [
                              _c("el-dropdown-item", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "moduloAcao",
                                    on: {
                                      click: function($event) {
                                        return _vm.desconectarCliente(
                                          cliente.clientId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "far fa-power-off",
                                      style: {
                                        "font-size": "20px",
                                        "margin-right": "8px"
                                      }
                                    }),
                                    _c("p", [_vm._v("Desconectar")])
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "linha" }),
            _c("div", { staticClass: "infoModulos" }, [
              _c("p", [
                _c("strong", { staticClass: "dado" }, [
                  _vm._v("Remetente ID:")
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.encurtarString(
                        cliente.clientId.length,
                        15,
                        cliente.clientId
                      )
                    )
                  )
                ])
              ]),
              _c("p", [
                _c("strong", { staticClass: "dado" }, [_vm._v("Status:")]),
                _c("span", [
                  _vm._v(_vm._s(cliente.qrCode ? "Pendente" : "Ativo"))
                ])
              ])
            ]),
            _c(
              "div",
              { staticClass: "qrCodeContainer" },
              [
                cliente.qrCode
                  ? _c("el-image", {
                      style: { width: "200px", height: "200px" },
                      attrs: { src: cliente.qrCode, fit: "contain" }
                    })
                  : _c("div", { staticClass: "conatinerClienteConectado" }, [
                      _c("span", [_vm._v("Remetente conectado!")])
                    ])
              ],
              1
            ),
            cliente.qrCode
              ? _c("div", { staticClass: "row-center" }, [
                  _c("strong", [
                    _vm._v("Leia o QR code para conectar seu dispositivo")
                  ])
                ])
              : _vm._e()
          ],
          1
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "formOptionContainer" },
      [
        _c(
          "el-radio-group",
          {
            model: {
              value: _vm.selectedAction,
              callback: function($$v) {
                _vm.selectedAction = $$v
              },
              expression: "selectedAction"
            }
          },
          [
            _c("el-radio-button", {
              attrs: { label: "Disparar mensagem individual" }
            }),
            _c("el-radio-button", {
              attrs: { label: "Criar disparo em massa" }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm.selectedAction === "Disparar mensagem individual"
      ? _c(
          "div",
          { staticClass: "messageFormContainer" },
          [
            _c(
              "el-form",
              {
                ref: "messageForm",
                attrs: {
                  model: _vm.messageForm,
                  rules: _vm.rules,
                  "label-width": "120px",
                  "label-position": "top"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Selecione o remetente",
                              prop: "clientId"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "Selecione um cliente" },
                                model: {
                                  value: _vm.messageForm.clientId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.messageForm, "clientId", $$v)
                                  },
                                  expression: "messageForm.clientId"
                                }
                              },
                              _vm._l(_vm.clientesConectados, function(cliente) {
                                return _c("el-option", {
                                  key: cliente.clientId,
                                  attrs: {
                                    label: cliente.clientId,
                                    value: cliente.clientId
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Número", prop: "numero" } },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: [
                                    "+## (##) ####-####",
                                    "+## (##) #####-####"
                                  ],
                                  expression:
                                    "['+## (##) ####-####', '+## (##) #####-####']"
                                }
                              ],
                              attrs: {
                                placeholder: "Insira o número do destinatário"
                              },
                              model: {
                                value: _vm.messageForm.numero,
                                callback: function($$v) {
                                  _vm.$set(_vm.messageForm, "numero", $$v)
                                },
                                expression: "messageForm.numero"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Mensagem", prop: "mensagem" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 5,
                        placeholder: "Insira a mensagem"
                      },
                      model: {
                        value: _vm.messageForm.mensagem,
                        callback: function($$v) {
                          _vm.$set(_vm.messageForm, "mensagem", $$v)
                        },
                        expression: "messageForm.mensagem"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.enviarMensagem }
                      },
                      [_vm._v("Enviar Mensagem")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm.selectedAction === "Criar disparo em massa"
      ? _c(
          "div",
          { staticClass: "uploadContainer" },
          [
            _c(
              "div",
              { staticClass: "statusContainer" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "totalCard",
                            attrs: { shadow: "hover" }
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "Total de Mensagens: " +
                                  _vm._s(
                                    _vm.statusDisparo.totalPendente +
                                      _vm.statusDisparo.totalDisparado
                                  )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "pendenteCard",
                            attrs: { shadow: "hover" }
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "Total Pendente: " +
                                  _vm._s(_vm.statusDisparo.totalPendente)
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "disparadoCard",
                            attrs: { shadow: "hover" }
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "Total Disparado: " +
                                  _vm._s(_vm.statusDisparo.totalDisparado)
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form",
              {
                ref: "massMessageForm",
                attrs: {
                  model: _vm.massMessageForm,
                  rules: _vm.massRules,
                  "label-width": "120px",
                  "label-position": "top"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Mensagem", prop: "massMensagem" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 5,
                        maxlength: "500",
                        placeholder: "Insira a mensagem (máx. 500 caracteres)"
                      },
                      model: {
                        value: _vm.massMessageForm.massMensagem,
                        callback: function($$v) {
                          _vm.$set(_vm.massMessageForm, "massMensagem", $$v)
                        },
                        expression: "massMessageForm.massMensagem"
                      }
                    }),
                    _c("small", [
                      _vm._v(
                        "caracteres " +
                          _vm._s(_vm.massMessageForm.massMensagem.length) +
                          "/500"
                      )
                    ]),
                    _c("br"),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(
                        "Utilize as seguintes variáveis para personalizar a mensagem:"
                      ),
                      _c("br"),
                      _vm._v(
                        _vm._s(_vm.variavis[0].nome) +
                          " -> substitui o número do processo"
                      ),
                      _c("br"),
                      _vm._v(
                        _vm._s(_vm.variavis[1].nome) +
                          " -> substitui o nome do interessado"
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "Selecione o arquivo com os números de processos",
                      prop: "file"
                    }
                  },
                  [
                    _c("app-upload-area", {
                      key: _vm.uploadFileComponentKey,
                      attrs: {
                        id: "lote",
                        target: "publico/upload",
                        fileType: _vm.validExtensions,
                        onSuccess: _vm.onSuccess,
                        documento: _vm.file,
                        hasDownloadButton: false
                      },
                      on: { removerDocumento: _vm.removerDocumento },
                      model: {
                        value: _vm.file,
                        callback: function($$v) {
                          _vm.file = $$v
                        },
                        expression: "file"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c("span", [_vm._v("Selecione o arquivo de imagem")]),
                    _c("app-upload-area", {
                      attrs: {
                        id: "imagem-whatsapp",
                        target: "publico/upload",
                        fileType: _vm.validExtensionsImagem,
                        onSuccess: _vm.onSuccessImagem,
                        documento: _vm.imagem,
                        hasDownloadButton: false,
                        maxSize: 4
                      },
                      on: { removerDocumento: _vm.removerImagem },
                      model: {
                        value: _vm.imagem,
                        callback: function($$v) {
                          _vm.imagem = $$v
                        },
                        expression: "imagem"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.criarDisparoMassa }
                      },
                      [_vm._v("Criar Disparo em Massa")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2538bf72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2538bf72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/ma/WapClientsMa.vue
// module id = null
// module chunks = 